<template>
  <el-menu
    v-if="!update"
    :mode="mode"
    :collapse="collapse"
    :menu-trigger="options.menuTrigger"
    :default-active="activeIndex"
    @select="handleSelect"
    @open="handleOpen"
    @close="handleClose"
    :style="getAppearanceStyle"
    ref="navMenu"
    class="el-menu--vertical"
    :class="{ menu_bigscreen: request_prefix === 'bigScreen' }"
  >
    <template v-for="(option, index) in selectOptions">
      <el-menu-item
        :style="getStyle"
        v-if="!option.children || option.children.length === 0"
        :ref="`menuItem${index}`"
        :key="index"
        :index="'' + (index + 1)"
      >
        <template>
          <!-- <img v-if="option.iconUrl" class="data-icon" :src="option.iconUrl" alt="" /> -->
          <span :style="getTextColor" :data-label="options.topNavTextLimitCount">
            {{ options.topNavTextLimit ? option.label.substr(0, options.topNavTextLimitCount) : option.label }}
          </span>
        </template>
      </el-menu-item>
      <el-submenu
        :ref="`menuItem${index}`"
        :style="getStyle"
        :popper-append-to-body="false"
        v-if="option.children && option.children.length > 0"
        :key="index"
        :index="'' + (index + 1)"
        @click.native="handleMenuClick(index + 1, option)"
      >
        <template slot="title">
          <!-- <img v-if="option.iconUrl" class="data-icon" :src="option.iconUrl" alt="" /> -->
          <span v-if="getIconPosition === 'right'" :style="getTextColor">{{
            options.topNavTextLimit ? option.label.substr(0, options.topNavTextLimitCount) : option.label
          }}</span>
          <cxIcon
            :class="getIconPosition === 'right' ? 'right-icon icon' : 'left-icon icon'"
            v-if="iconType === 'icon'"
            :options="options"
            :iconStyle="getIconStyle"
          ></cxIcon>
          <img
            :class="getIconPosition === 'right' ? 'right-icon icon' : 'left-icon icon'"
            v-else-if="iconType === 'img' && iconSrc"
            :src="iconSrc"
            :style="getIconImgStyle"
          />
          <span v-if="getIconPosition === 'left'" :style="getTextColor">{{
            options.topNavTextLimit ? option.label.substr(0, options.topNavTextLimitCount) : option.label
          }}</span>
        </template>
        <cx-menu-tree
          :style="getPopperStyle"
          v-for="(child_option, child_index) in option.children"
          :key="'child_' + child_index"
          :items="child_option"
          :options="options"
          :index="index + 1 + '_' + (child_index + 1)"
          @handleMenuClick="handleMenuClick"
        />
      </el-submenu>
    </template>
  </el-menu>
</template>

<script>
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import { findCurrentComponentPathInLayoutByRectId } from "utils/index"
import eventMixin from "utils/event/eventMixin.js"
import subPageEventMixin from "utils/event/subPageEventMixin.js"
import cxMenuTree from "./cxMenuTree.vue"
export default {
  mixins: [eventMixin, subPageEventMixin],
  components: { cxMenuTree },
  props: {
    options: {
      type: Object
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      activeIndex: "0",
      update: false
    }
  },
  computed: {
    ids() {
      return this.myid
    },
    mode() {
      return this.options.mode
    },
    collapse() {
      return this.options.collapse
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    iconSrc() {
      return this.options ? this.options.iconSrc : ""
    },
    iconType() {
      return this.options ? this.options.iconType : "img"
    },
    getIconPosition() {
      return this.options ? this.options.iconPosition : "left"
    },
    getMargin() {
      return this.options.iconPosition === "left"
        ? `0 ${this.options.iconMargin}px 0 0`
        : `0 0 0 ${this.options.iconMargin}px`
    },
    getIconStyle() {
      let rightStyle = {}
      if (this.getIconPosition === "right") {
        rightStyle = {
          position: "absolute",
          right: "10px",
          top: "50%"
        }
      }
      return {
        ...rightStyle,
        display: "inline-block",
        // "--iconColor": this.options.iconColorIsThemeColor ? this.themeColor : this.options.iconColor,
        "--iconColor": this.$parseColor(this.options.iconColor, {
          isThemeColor: this.options.iconColorIsThemeColor
        }),
        fontSize: this.options.iconWidth + "px",
        width: this.options.iconWidth + "px",
        height: this.options.iconWidth + "px",
        margin: this.getMargin
      }
    },
    getIconImgStyle() {
      let rightStyle = {}
      if (this.getIconPosition === "right") {
        rightStyle = {
          position: "absolute",
          right: "10px",
          top: "50%"
        }
      }
      return {
        ...rightStyle,
        display: "inline-block",
        width: this.options.iconWidth + "px",
        margin: this.getMargin
      }
    },
    backgroundColor() {
      // return this.options.bgIsThemeColor ? this.themeColor : this.options.bgColor
      return this.$parseColor(this.options.bgColor, {
        isThemeColor: this.options.bgIsThemeColor
      })
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    liActiveBg() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.liActiveBgColor
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("liActiveBgIsThemeColor")
              ? this.options.liActiveBgIsThemeColor
              : false,
            color: this.options.liActiveBgColor.color
              ? this.options.liActiveBgColor.color
              : this.options.liActiveBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    liHoverBgStyle() {
      if (this.options.liHoverIsSameActive) {
        console.log("liActiveBgStyle", this.liActiveBg)
        return {
          "--hoverBackgroundImage1": this.liActiveBg.backgroundImage,
          "--hoverBackgroundSize1": this.liActiveBg.backgroundSize,
          "--hoverBackgroundPosition1": this.liActiveBg.backgroundPosition,
          "--hoverBackgroundRepeat1": this.liActiveBg.backgroundRepeat,
          "--hoverBackgroundColor1": this.liActiveBg.backgroundColor
        }
      }
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.liHoverBgColor
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("liHoverBgIsThemeColor")
              ? this.options.liHoverBgIsThemeColor
              : false,
            color: this.options.liHoverBgColor.color ? this.options.liHoverBgColor.color : this.options.liHoverBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return {
        "--hoverBackgroundImage1": containerBg.backgroundImage,
        "--hoverBackgroundSize1": containerBg.backgroundSize,
        "--hoverBackgroundPosition1": containerBg.backgroundPosition,
        "--hoverBackgroundRepeat1": containerBg.backgroundRepeat,
        "--hoverBackgroundColor1": containerBg.backgroundColor
      }
    },
    liActiveBgStyle() {
      return {
        "--activeBackgroundImage1": this.liActiveBg.backgroundImage,
        "--activeBackgroundSize1": this.liActiveBg.backgroundSize,
        "--activeBackgroundPosition1": this.liActiveBg.backgroundPosition,
        "--activeBackgroundRepeat1": this.liActiveBg.backgroundRepeat,
        "--activeBackgroundColor1": this.liActiveBg.backgroundColor
      }
    },
    topNavBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.topNavBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.topNavBgColorIsThemeColor ? true : false,
            color: this.options.topNavBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    topNavBgStyle1() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.topNavBackground1
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.topNavBgColorIsThemeColor ? true : false,
            color: this.options.topNavBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    hoverBgStyle() {
      if (this.options.hoverIsSameActive) {
        return {
          "--hoverBackgroundImage": this.activeBg.backgroundImage,
          "--hoverBackgroundSize": this.activeBg.backgroundSize,
          "--hoverBackgroundPosition": this.activeBg.backgroundPosition,
          "--hoverBackgroundRepeat": this.activeBg.backgroundRepeat,
          "--hoverBackgroundColor": this.activeBg.backgroundColor
        }
      }
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.hoverBgColor
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hoverBgIsThemeColor ? true : false,
            color: this.options.hoverBgColor.color ? this.options.hoverBgColor.color : this.options.hoverBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return {
        "--hoverBackgroundImage": containerBg.backgroundImage,
        "--hoverBackgroundSize": containerBg.backgroundSize,
        "--hoverBackgroundPosition": containerBg.backgroundPosition,
        "--hoverBackgroundRepeat": containerBg.backgroundRepeat,
        "--hoverBackgroundColor": containerBg.backgroundColor
      }
    },
    activeBg() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.activeBgColor
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.activeBgIsThemeColor ? true : false,
            color: this.options.activeBgColor.color ? this.options.activeBgColor.color : this.options.activeBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    activeBgStyle() {
      return {
        "--activeBackgroundImage": this.activeBg.backgroundImage,
        "--activeBackgroundSize": this.activeBg.backgroundSize,
        "--activeBackgroundPosition": this.activeBg.backgroundPosition,
        "--activeBackgroundRepeat": this.activeBg.backgroundRepeat,
        "--activeBackgroundColor": this.activeBg.backgroundColor
      }
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    topNavBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.topNavBoxShadowH)) {
        this.options.topNavBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.topNavBoxShadowH[index]}px ${_this.options.topNavBoxShadowV[index]}px ${_this.options.topNavBoxShadowBlur[index]}px ${_this.options.topNavBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.topNavBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.topNavBoxShadowH}px ${this.options.topNavBoxShadowV}px ${this.options.topNavBoxShadowBlur}px ${this.options.topNavBoxShadowSpread}px ${this.$parseColor(this.options.topNavBoxShadowColor)}`
      }
      return tmpStyle
    },
    /* 次级菜单的默认投影 */
    liBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.selectBoxShadowH)) {
        this.options.selectBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.selectBoxShadowH[index]}px ${_this.options.selectBoxShadowV[index]}px ${_this.options.selectBoxShadowBlur[index]}px ${_this.options.selectBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.selectBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.selectBoxShadowH}px ${this.options.selectBoxShadowV}px ${this.options.selectBoxShadowBlur}px ${this.options.selectBoxShadowSpread}px ${this.$parseColor(this.options.selectBoxShadowColor)}`
      }
      return tmpStyle
    },
    getAppearanceStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      //  解决树形菜单在纵向或者横向排列布局内，高度适应内容的情况下会出现圆角失效的情况
      let overStr = {}
      if(this.options.heightType === "自动"){
        overStr = {
          "overflow": this.options.heightType === "自动" ? "hidden" : ""
        }
      }
      return {
        ...this.bgStyle,
        "background-color": this.bgStyle.backgroundColor,
        opacity: this.options.opacity / 100,
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor && this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": borderW,
        "box-shadow": this.boxShadowStyle,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        height: "100%",
        "overflow-y": this.options.heightType !== "自动" ? "auto" : "", // 设置高度自适应时会出现滚动条
          ...overStr,
      }
    },
    getTextColor() {
      let colorName = "colorArr",
        oldColorName = "color",
        colorIsThemeColor = "textIsThemeColor"
      let hoverColorName = "hoverFontColorArr",
        hoverOldColorName = "hoverFontColor",
        hoverColorIsThemeColor = "hoverTextIsThemeColor"
      let activeColorName = "activeFontColorArr",
        activeOldColorName = "activeFontColor",
        activeColorIsThemeColor = "activeTextIsThemeColor"
      let hoverColor = {},
        activeColor = {}
      // 激活颜色
      if (this.options[activeColorName]?.isThemeColor ?? this.options[activeColorIsThemeColor]) {
        activeColor = {
          "--activeColor": this.$parseColor(this.options[activeColorName], {isThemeColor: true})
        }
      } else if (!this.options[activeColorName]) {
        activeColor = {
          // "--activeColor": this.options[activeOldColorName].color
          //   ? this.options[activeOldColorName].color
          //   : this.options[activeOldColorName]
          "--activeColor": this.$parseColor(this.options[activeOldColorName], {
            isThemeColor: this.options[activeColorIsThemeColor]
          }),
        }
      } else if (this.options[activeColorName].type === "color") {
        activeColor = {
          // "--activeColor": this.options[activeColorName].color
          //   ? this.options[activeColorName].color
          //   : this.options[activeColorName].data?.stops[0][0]
          "--activeColor": this.$parseColor(this.options[activeColorName],{
            isThemeColor: this.options[activeColorIsThemeColor]
          }),
        }
      } else if (this.options[activeColorName].type === "linearGradient") {
        //老数据兼容 有些colorArr.data.stops不是数组
        let tmp = []
        this.options[activeColorName].data.stops.forEach(item => {
          tmp.push(item[0] + " " + item[1] * 100 + "%")
        })
        activeColor = {
          "--activeColor": "transparent",
          // "--activeBackgroundImage": `-webkit-linear-gradient(${
          //   this.options[activeColorName].data.angle
          // }deg, ${tmp.join(",")})`,
          "--activeBackgroundImage": this.$parseColor(this.options[activeColorName],{
            isThemeColor: this.options[activeColorIsThemeColor]
          }),
          "-webkit-background-clip": "text"
        }
      }

      // 悬浮颜色
      if (this.options.hoverIsSameActive) {
        hoverColor = {
          "--hoverColor": activeColor["--activeColor"],
          "--hoverBackgroundImage": activeColor["--activeBackgroundImage"],
          "-webkit-background-clip": "text"
        }
      } else {
        if (this.options[hoverColorName]?.isThemeColor ?? this.options[hoverColorIsThemeColor]) {
          hoverColor = {
            "--hoverColor": this.themeColor
          }
        } else if (!this.options[hoverColorName]) {
          hoverColor = {
            // "--hoverColor": this.options[hoverOldColorName].color
            //   ? this.options[hoverOldColorName].color
            //   : this.options[hoverOldColorName]
            "--hoverColor": this.$parseColor(this.options[hoverOldColorName],{
              isThemeColor: this.options[hoverColorIsThemeColor]
            }),
          }
        } else if (this.options[hoverColorName].type === "color") {
          hoverColor = {
            // "--hoverColor": this.options[hoverColorName].color
            //   ? this.options[hoverColorName].color
            //   : this.options[hoverColorName].data?.stops[0][0]
            "--hoverColor": this.$parseColor(this.options[hoverColorName], {
              isThemeColor: this.options[hoverColorIsThemeColor]
            }),
          }
        } else if (this.options[hoverColorName].type === "linearGradient") {
          //老数据兼容 有些colorArr.data.stops不是数组
          let tmp = []
          this.options[hoverColorName].data.stops.forEach(item => {
            tmp.push(item[0] + " " + item[1] * 100 + "%")
          })
          hoverColor = {
            "--hoverColor": "transparent",
            // "--hoverBackgroundImage": `-webkit-linear-gradient(${this.options[colorName].data.angle}deg, ${tmp.join(
            //   ","
            // )})`,
            "--hoverBackgroundImage": this.$parseColor(this.options[hoverColorName],{
              isThemeColor: this.options[hoverColorIsThemeColor]
            }),
            "-webkit-background-clip": "text"
          }
        }
      }
      // 常规颜色
      if (this.options[colorIsThemeColor]) {
        return {
          ...activeColor,
          ...hoverColor,
          color: this.themeColor
        }
      } else if (!this.options[colorName]) {
        return {
          ...activeColor,
          ...hoverColor,
          // color: this.options[oldColorName]
          color: this.$parseColor(this.options[oldColorName], {
            isThemeColor: this.options[colorIsThemeColor]
          }),
        }
      } else if (this.options[colorName].type === "color") {
        return {
          ...activeColor,
          ...hoverColor,
          // color: this.options[colorName].color
          //   ? this.options[colorName].color
          //   : this.options[colorName].data?.stops[0][0]
          color: this.$parseColor(this.options[colorName], {
            isThemeColor: this.options[colorIsThemeColor]
          }),
        }
      } else if (this.options[colorName].type === "linearGradient") {
        //老数据兼容 有些colorArr.data.stops不是数组
        let tmp = []
        this.options[colorName].data.stops.forEach(item => {
          tmp.push(item[0] + " " + item[1] * 100 + "%")
        })
        return {
          ...activeColor,
          ...hoverColor,
          color: "transparent",
          // backgroundImage: `-webkit-linear-gradient(${this.options[colorName].data.angle}deg, ${tmp.join(",")})`,
          backgroundImage: this.$parseColor(this.options[colorName], {
            isThemeColor: this.options[colorIsThemeColor]
          }),
          "-webkit-background-clip": "text"
        }
      }
    },
    getStyle() {
      let topNavBorderW = "",
        activeBorderW = "",
        hoverBorderW = "",
        actualLineHeight = this.options.lineHeightType === '%' ? (this.options.lineHeight / 100 * this.options.fontSize) : this.options.lineHeight,
        height = Number(actualLineHeight)
      if (Array.isArray(this.options.topNavBorderWidth)) {
        this.options.topNavBorderWidth.forEach(item => [(topNavBorderW += `${item}px `)])
        height = `${height + this.options.topNavBorderWidth[0] + this.options.topNavBorderWidth[1]}px`
      } else {
        topNavBorderW += ` ${this.options.topNavBorderWidth}px`
        height = `${height + 2 * this.options.topNavBorderWidth}px`
      }
      if (Array.isArray(this.options.activeBorderWidth)) {
        this.options.activeBorderWidth.forEach(item => [(activeBorderW += `${item}px `)])
      } else {
        activeBorderW += ` ${this.options.activeBorderWidth}px`
      }
      if (Array.isArray(this.options.hoverBorderWidth)) {
        this.options.hoverBorderWidth.forEach(item => [(hoverBorderW += `${item}px `)])
      } else {
        hoverBorderW += ` ${this.options.hoverBorderWidth}px`
      }
      topNavBorderW = topNavBorderW.trim()
      activeBorderW = activeBorderW.trim()
      hoverBorderW = hoverBorderW.trim()

      let borderBottomWidth = this.options.clearLastBorder
        ? "0px"
        : topNavBorderW.split(" ").length > 1
        ? topNavBorderW.split(" ")[2]
        : topNavBorderW
      let hoverBorderBottomWidth = this.options.clearHoverLastBorder
        ? "0px"
        : this.options.hoverIsSameActive
        ? activeBorderW
        : hoverBorderW.split(" ").length > 1
        ? hoverBorderW.split(" ")[2]
        : hoverBorderW
      let activeBorderBottomWidth = this.options.clearLastBorder
        ? "0px"
        : activeBorderW.split(" ").length > 1
        ? activeBorderW.split(" ")[2]
        : activeBorderW
      console.log("this.options.clearLastBorder", this.options.clearLastBorder)
      let bg = {
        "--backgroundImage": this.topNavBgStyle?.backgroundImage,
        "--backgroundSize": this.topNavBgStyle?.backgroundSize,
        "--backgroundPosition": this.topNavBgStyle?.backgroundPosition,
        "--backgroundRepeat": this.topNavBgStyle?.backgroundRepeat,
        "--backgroundColor": this.topNavBgStyle?.backgroundColor
      }
      // let activeColor = this.options.activeTextIsThemeColor
      //   ? this.themeColor
      //   : this.options.activeFontColor && this.options.activeFontColor.color
      //   ? this.options.activeFontColor.color
      //   : this.options.activeFontColor
      // let hoverBorderColor = this.options.hoverIsSameActive
      //   ? this.options.activeBorderIsThemeColor
      //     ? this.themeColor
      //     : this.options.activeBorderColor && this.options.activeBorderColor.color
      //     ? this.options.activeBorderColor.color
      //     : this.options.activeBorderColor
      //   : this.options.hoverBorderIsThemeColor
      //   ? this.themeColor
      //   : this.options.hoverBorderColor && this.options.hoverBorderColor.color
      //   ? this.options.hoverBorderColor.color
      //   : this.options.hoverBorderColor
      let hoverBorderColor = this.options.hoverIsSameActive ? this.$parseColor(this.options.activeBorderColor, {
        isThemeColor: this.options.activeBorderIsThemeColor
      }) : this.$parseColor(this.options.hoverBorderColor, {
        isThemeColor: this.options.hoverBorderIsThemeColor
      })

      // let hoverBackground = this.options.hoverIsSameActive
      //   ? this.options.activeBgIsThemeColor
      //     ? this.themeColor
      //     : this.options.activeBgColor
      //   : this.options.hoverBgIsThemeColor
      //   ? this.themeColor
      //   : this.options.hoverBgColor
      let hoverBackground = this.options.hoverIsSameActive ? this.$parseColor(this.options.activeBgColor, {
        isThemeColor: this.options.activeBgIsThemeColor
      }) : this.$parseColor(this.options.hoverBgColor, {
        isThemeColor: this.options.hoverBgIsThemeColor
      })
      console.log("hoverBackground", hoverBackground)
      let actualActiveLineHeight = this.options.activeLineHeightType === '%' ? (this.options.activeLineHeight / 100 * this.options.activeFontSize) : this.options.activeLineHeight;
      let actualHoverLineHeight = this.options.hoverLineHeightType === '%' ? (this.options.hoverLineHeight / 100 * this.options.hoverFontSize) : this.options.hoverLineHeight;
      return {
        ...bg,
        ...this.activeBgStyle,
        ...this.hoverBgStyle,
        "--lineHeight": actualLineHeight + "px",
        "--height": height,
        "--navWidth": this.options.widthAuto ? "" : this.options.navWidth + "px",
        // "--color": this.options.textIsThemeColor ? this.themeColor : this.getColor('color','colorArr'),
        "--fontWeight": this.options.fontWeight,
        "--fontSize": this.options.fontSize + "px",
        "--fontFamily": this.options.fontFamily,
        "--background": this.backgroundColor,
        "--textAlign": this.options.textAlign,
        "--writingMode": this.options.writingMode,
        "--letterSpacing": this.options.letterSpacing + "px",
        "--textDecoration": this.options.textDecoration,
        "--fontStyle": this.options.fontStyle,
        "--borderRadius": `${this.options.topNavBorderTopLeftRadius}px ${this.options.topNavBorderTopRightRadius}px ${this.options.topNavBorderBottomRightRadius}px ${this.options.topNavBorderBottomLeftRadius}px`,
        "--borderStyle": this.options.topNavBorderStyle,
        // "--borderColor": this.options.topNavBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.topNavBorderColor && this.options.topNavBorderColor.color
        //   ? this.options.topNavBorderColor.color
        //   : this.options.topNavBorderColor,
        "--borderColor": this.$parseColor(this.options.topNavBorderColor, {
          isThemeColor: this.options.topNavBorderIsThemeColor
        }),
        "--borderWidth": topNavBorderW,
        "--borderBottomWidth": borderBottomWidth,
        "--boxShadow": this.topNavBoxShadowStyle,
        "--popperWidth": this.liIsSameSize ? undefined : this.options.liWidth + "px",
        // "--padding": this.getPaddingStyle,
        // "--activeBgColor": this.options.activeBgIsThemeColor ? this.themeColor : this.options.activeBgColor,
        "--activeBorderWidth": activeBorderW,
        "--activeBorderBottomWidth": activeBorderBottomWidth,
        "--activeBorderStyle": this.options.activeBorderStyle,
        // "--activeBorderColor": this.options.activeBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.activeBorderColor && this.options.activeBorderColor.color
        //   ? this.options.activeBorderColor.color
        //   : this.options.activeBorderColor,
        "--activeBorderColor": this.$parseColor(this.options.activeBorderColor, {
          isThemeColor: this.options.activeBorderIsThemeColor
        }),
        // "--activeColor": activeColor,
        "--activeFontWeight": this.options.activeFontWeight,
        "--activeFontSize": this.options.activeFontSize + "px",
        "--activeFontFamily": this.options.activeFontFamily,
        "--activeTextAlign": this.options.activeTextAlign,
        "--activeLineHeight": actualActiveLineHeight + "px",
        "--activeWritingMode": this.options.activeWritingMode,
        "--activeLetterSpacing": this.options.activeLetterSpacing + "px",
        "--activeTextDecoration": this.options.activeTextDecoration,
        "--activeFontStyle": this.options.activeFontStyle,
        "--liBoxShadowStyle": this.liBoxShadowStyle,
        // "--hoverBgColor": this.options.hoverIsSameActive
        //   ? this.options.activeBgIsThemeColor
        //     ? this.themeColor
        //     : this.options.activeBgColor
        //   : this.options.hoverBgIsThemeColor
        //   ? this.themeColor
        //   : this.options.hoverBgColor && this.options.hoverBgColor.color
        //   ? this.options.hoverBgColor.color
        //   : this.options.hoverBgColor,
        "--hoverBorderColor": hoverBorderColor,
        // "--hoverColor": this.options.hoverIsSameActive
        //   ? activeColor
        //   : this.options.hoverTextIsThemeColor
        //   ? this.themeColor
        //   : this.options.hoverFontColor && this.options.hoverFontColor.color
        //   ? this.options.hoverFontColor.color
        //   : this.options.hoverFontColor,
        "--hoverBorderWidth": this.options.hoverIsSameActive ? activeBorderW : hoverBorderW,
        "--hoverBorderBottomWidth": hoverBorderBottomWidth,
        "--hoverBorderStyle": this.options.hoverIsSameActive
          ? this.options.activeBorderStyle
          : this.options.hoverBorderStyle,
        "--hoverFontWeight": this.options.hoverIsSameActive
          ? this.options.activeFontWeight
          : this.options.hoverFontWeight,
        "--hoverFontSize": this.options.hoverIsSameActive
          ? this.options.activeFontSize + "px"
          : this.options.hoverFontSize + "px",
        "--hoverFontFamily": this.options.hoverIsSameActive
          ? this.options.activeFontFamily
          : this.options.hoverFontFamily,
        "--hoverTextAlign": this.options.hoverIsSameActive ? this.options.activeTextAlign : this.options.hoverTextAlign,
        "--hoverLineHeight": this.options.hoverIsSameActive
          ? actualActiveLineHeight + "px"
          : actualHoverLineHeight + "px",
        "--hoverWritingMode": this.options.hoverIsSameActive
          ? this.options.activeWritingMode
          : this.options.hoverWritingMode,
        "--hoverLetterSpacing": this.options.hoverIsSameActive
          ? this.options.activeLetterSpacing + "px"
          : this.options.hoverLetterSpacing + "px",
        "--hoverTextDecoration": this.options.hoverIsSameActive
          ? this.options.activeTextDecoration
          : this.options.hoverTextDecoration,
        "--hoverFontStyle": this.options.hoverIsSameActive ? this.options.activeFontStyle : this.options.hoverFontStyle,
        /*"--ulBackground": this.options.ulBgIsThemeColor
          ? this.themeColor
          : this.options.ulBgColor && this.options.ulBgColor.color
          ? this.options.ulBgColor.color
          : this.options.ulBgColor,*/
        "--leftIndent": this.options.indent + "px",
        "--hoverBackground": hoverBackground,
        "--marginBottom": (this.options.topNavMarginBottom || 0) + "px",
        // "--liBackground": this.options.liBgIsThemeColor
        //   ? this.themeColor
        //   : this.options.liBgColor && this.options.liBgColor.color
        //   ? this.options.liBgColor.color
        //   : this.options.liBgColor
        "--liBackground": this.$parseColor(this.options.liBgColor, {
          isThemeColor: this.options.liBgIsThemeColor
        }),
      }
    },
    getPopperStyle() {
      // hover
      let borderW = "",
        hoverBorderW = ""
      if (Array.isArray(this.options.liBorderWidth)) {
        this.options.liBorderWidth.forEach(item => [(borderW += `${item}px `)])
      } else {
        borderW += ` ${this.options.liBorderWidth}px`
      }
      if (Array.isArray(this.options.liHoverBorderWidth)) {
        this.options.liHoverBorderWidth.forEach(item => [(hoverBorderW += `${item}px `)])
      } else {
        hoverBorderW += ` ${this.options.liHoverBorderWidth}px`
      }
      borderW = borderW.trim()
      // active
      let activeBorderW = ""
      if (Array.isArray(this.options.liActiveBorderWidth)) {
        this.options.liActiveBorderWidth.forEach(item => [(activeBorderW += `${item}px `)])
      } else {
        activeBorderW += ` ${this.options.liActiveBorderWidth}px`
      }
      activeBorderW = activeBorderW.trim()
      hoverBorderW = !this.options.liHoverIsSameActive ? hoverBorderW.trim() : activeBorderW
      let liBorderBottomWidth = this.options.clearLiLastBorder
        ? "0px"
        : borderW.split(" ").length > 1
        ? borderW.split(" ")[2]
        : borderW
      let liHoverBorderBottomWidth = this.options.liHoverIsSameActive
        ? liBorderBottomWidth
        : this.options.clearLiHoverLastBorder
        ? "0px"
        : hoverBorderW.split(" ").length > 1
        ? hoverBorderW.split(" ")[2]
        : hoverBorderW
      let liActiveBorderBottomWidth = this.options.clearLiActiveLastBorder
        ? "0px"
        : activeBorderW.split(" ").length > 1
        ? activeBorderW.split(" ")[2]
        : activeBorderW
      let bg = {
        "--backgroundImage1": this.topNavBgStyle1?.backgroundImage,
        "--backgroundSize1": this.topNavBgStyle1?.backgroundSize,
        "--backgroundPosition1": this.topNavBgStyle1?.backgroundPosition,
        "--backgroundRepeat1": this.topNavBgStyle1?.backgroundRepeat,
        "--backgroundColor1": this.topNavBgStyle1?.backgroundColor
      }
      // let liActiveFontColor = this.options.liActiveTextIsThemeColor
      //   ? this.themeColor
      //   : this.options.liActiveFontColor && this.options.liActiveFontColor.color
      //   ? this.options.liActiveFontColor.color
      //   : this.options.liActiveFontColor
      let actualLiActiveLineHeight = this.options.liActiveLineHeightType === '%' ? (this.options.liActiveLineHeight / 100 * this.options.liActiveFontSize) : this.options.liActiveLineHeight
      let actualLiHoverLineHeight = this.options.liHoverLineHeightType === '%' ? (this.options.liHoverLineHeight / 100 * this.options.liHoverFontSize) : this.options.liHoverLineHeight
      // let liActiveBorderColor = this.options.liActiveBorderIsThemeColor
      //   ? this.themeColor
      //   : this.options.liActiveBorderColor && this.options.liActiveBorderColor.color
      //   ? this.options.liActiveBorderColor.color
      //   : this.options.liActiveBorderColor
      let liActiveBorderColor = this.$parseColor(this.options.liActiveBorderColor, {
        isThemeColor: this.options.liActiveBorderIsThemeColor
      })
      let liActiveLineHeight = this.options.liIsSameSize
        ? actualLiActiveLineHeight + "px"
        : this.options.liHeight + "px"
      let actualLiLineHeight = this.options.liLineHeightType === '%' ? (this.options.liLineHeight / 100 * this.options.liFontSize) : this.options.liLineHeight
      //  liIsSameSize  尺寸自动
      return {
        ...this.liActiveBgStyle,
        ...this.liHoverBgStyle,
        "--liLineHeight": actualLiLineHeight + "px",
        "--liHeight": this.options.liIsSameSize ? "auto" : this.options.liHeight + "px",
        "--liWidth": this.options.liIsSameSize ? "" : this.options.liWidth + "px",
        // "--liColor": this.options.liIsThemeColor ? this.themeColor : this.options.liFontColor,
        "--liFontWeight": this.options.liFontWeight,
        "--liFontSize": this.options.liFontSize + "px",
        "--liFontFamily": this.options.liFontFamily,
        "--liFontStyle": this.options.liFontStyle,
        "--liTextAlign": this.options.liTextAlign,
        "--liWritingMode": this.options.liWritingMode,
        "--liLetterSpacing": this.options.liLetterSpacing + "px",
        "--liTextDecoration": this.options.liTextDecoration,
        "--liBorderWidth": borderW,
        "--liBorderBottomWidth": liBorderBottomWidth,
        "--liBorderStyle": this.options.liBorderStyle,
        // "--borderColor1": this.options.liBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.liBorderColor && this.options.liBorderColor.color
        //   ? this.options.liBorderColor.color
        //   : this.options.liBorderColor,
        "--borderColor1": this.$parseColor(this.options.liBorderColor, {
          isThemeColor: this.options.liBorderIsThemeColor
        }), 
        // "--liHoverColor": this.options.liHoverIsSameActive
        //   ? liActiveFontColor
        //   : this.options.liHoverTextIsThemeColor
        //   ? this.themeColor
        //   : this.options.liHoverFontColor && this.options.liHoverFontColor.color
        //   ? this.options.liHoverFontColor.color
        //   : this.options.liHoverFontColor,
        "--liHoverColor": this.options.liHoverIsSameActive ? liActiveFontColor : this.$parseColor(this.options.liHoverFontColor, {
          isThemeColor: this.options.liHoverTextIsThemeColor
        }), 
        "--liHoverFontWeight": this.options.liHoverIsSameActive
          ? this.options.liActiveFontWeight
          : this.options.liHoverFontWeight,
        "--liHoverFontStyle": this.options.liHoverIsSameActive
          ? this.options.liActiveFontStyle
          : this.options.liHoverFontStyle,
        "--liHoverFontSize":
          (this.options.liHoverIsSameActive ? this.options.liActiveFontSize : this.options.liHoverFontSize) + "px",
        "--liHoverFontFamily": this.options.liHoverIsSameActive
          ? this.options.liActiveFontFamily
          : this.options.liHoverFontFamily,
        "--liHoverTextAlign": this.options.liHoverIsSameActive
          ? this.options.liActiveTextAlign
          : this.options.liHoverTextAlign,
        "--liHoverWritingMode": this.options.liHoverIsSameActive
          ? this.options.liActiveWritingMode
          : this.options.liHoverWritingMode,
        "--liHoverLetterSpacing":
          (this.options.liHoverIsSameActive ? this.options.liActiveLetterSpacing : this.options.liHoverLetterSpacing) +
          "px",
        "--liHoverTextDecoration": this.options.liHoverIsSameActive
          ? this.options.liActiveTextDecoration
          : this.options.liHoverTextDecoration,
        "--liHoverBorderWidth": hoverBorderW,
        "--liHoverBorderBottomWidth": liHoverBorderBottomWidth,
        "--liHoverBorderStyle": this.options.liHoverIsSameActive
          ? this.options.liActiveBorderStyle
          : this.options.liHoverBorderStyle,
        // "--liHoverBorderColor": this.options.liHoverIsSameActive
        //   ? liActiveBorderColor
        //   : this.options.liHoverBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.liHoverBorderColor && this.options.liHoverBorderColor.color
        //   ? this.options.liHoverBorderColor.color
        //   : this.options.liHoverBorderColor,
        "--liHoverBorderColor": this.options.liHoverIsSameActive ? liActiveBorderColor : this.$parseColor(this.options.liHoverBorderColor, {
          isThemeColor: this.options.liHoverBorderIsThemeColor
        }), 
        // "--hoverBackground1": this.options.liHoverBgIsThemeColor
        //   ? this.themeColor
        //   : this.options.liHoverBgColor && this.options.liHoverBgColor.color
        //   ? this.options.liHoverBgColor.color
        //   : this.options.liHoverBgColor,
        "--liHoverLineHeight": this.options.liHoverIsSameActive
          ? liActiveLineHeight
          : actualLiHoverLineHeight + "px",
        // "--liActiveColor": liActiveFontColor,
        "--liActiveFontWeight": this.options.liActiveFontWeight,
        "--liActiveFontStyle": this.options.liActiveFontStyle,
        "--liActiveFontSize": this.options.liActiveFontSize + "px",
        "--liActiveFontFamily": this.options.liActiveFontFamily,
        "--liActiveTextAlign": this.options.liActiveTextAlign,
        "--liActiveWritingMode": this.options.liActiveWritingMode,
        "--liActiveLetterSpacing": this.options.liActiveLetterSpacing + "px",
        "--liActiveTextDecoration": this.options.liActiveTextDecoration,
        "--liActiveBorderWidth": activeBorderW,
        "--liActiveBorderBottomWidth": liActiveBorderBottomWidth,
        "--liActiveLineHeight": liActiveLineHeight,
        "--liActiveBorderStyle": this.options.liActiveBorderStyle,
        "--liActiveBorderColor": liActiveBorderColor,
        // "--activeBackground": this.options.liActiveBgIsThemeColor
        //   ? this.themeColor
        //   : this.options.liActiveBgColor && this.options.liActiveBgColor.color
        //   ? this.options.liActiveBgColor.color
        //   : this.options.liActiveBgColor,
        "--liMarginBottom": (this.options.liMarginBottom || 0) + "px",
        "--borderRadius1": `${this.options.topNavBorderTopLeftRadius1}px ${this.options.topNavBorderTopRightRadius1}px ${this.options.topNavBorderBottomRightRadius1}px ${this.options.topNavBorderBottomLeftRadius1}px`,
        ...bg
      }
    },
    selectOptions() {
      console.log("this.options.selectOptions", this.options.selectOptions)
      return this.options.selectOptions
    },
    // 只执行展开收起
    hasChildOnlyOpen() {
      return this.options.hasChildOnlyOpen || false
    }
  },
  mounted() {
    this.$initPlugin(this.options?.pluginName)
  },
  methods: {
    handleMenuClick(index, option) {
      if (option.openType === 2 && option.value && option.value.indexOf("http") > -1) {
        // 跳转外链
        // let target = option.openTarget === 2 ? '_blank':'_self'
        // mhDetail(option.value, target)
      }
    },
    handleSelect(path) {
      let pathArr = path.split("_")
      let val = {
        children: JSON.parse(JSON.stringify(this.selectOptions))
      }
      pathArr.forEach(pathIndex => {
        val = val.children[parseInt(pathIndex) - 1]
        // val = val.children[parseInt(pathIndex)]
      })
      let url = val?.publicId || val?.value
      console.log("url:" + url)
      if (this.myid.hasOwnProperty("directionIndex")) {
        // 说明当前组件是在自由布局组件中
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", {
          ...this.myid,
          option_name: "value",
          option_val: url
        })
      } else {
        this.$store.dispatch(this.request_prefix + "/changeOptions", {
          ...this.myid,
          option_name: "value",
          option_val: url
        })
        this.$store.dispatch(this.request_prefix + "/changeOptions", {
          ...this.myid,
          option_name: "label",
          option_val: val?.label
        })
      }
      // 此功能是用来保证 有下拉的时候，点击调走，不改变激活项
      this.$nextTick(() => {
        // 点击有展开项时添加选中状态 一级菜单
        this.activeIndex = path
        // if(val?.children?.length>0) {
        //   let item = this.$refs.menuItem
        //   item.forEach(menuItem=> {
        //     menuItem.$el.classList.remove("is-active")
        //   })
        //   item[pathArr[0]-1].$el.classList.add("is-active")
        // }

        // 用于选中有子级的一级菜单 和 选中子级菜单时选中当前一级菜单 取消其他一级菜单的选中状态
        // 当一级菜单有子菜单时 一级菜单的类名为 el-submenu
        Array.from(document.getElementsByClassName("el-submenu")).forEach(menuItem => {
          menuItem.classList.remove("is-active")
        })
        let currentMenuItem = this.$refs[`menuItem${[pathArr[0] - 1]}`][0]
        currentMenuItem.$el.classList.add("is-active")

        //   let item = this.$refs.menuItem
        //   if (pathArr.length > 1) {
        //     item[this.activeIndex].$el.classList.add("is-active")
        //     item[pathArr[0]].$el.classList.remove("is-active")
        //   } else {
        //     item[this.activeIndex].$el.classList.remove("is-active")
        //     this.activeIndex = path
        //   }
      })
      this.dispatchListPageRefreshData(url)
    },
    handleOpen(path) {
      /* 大屏屏蔽有下级菜单的菜单选中效果 */
      if (this.request_prefix !== "bigScreen" && !this.hasChildOnlyOpen) {
        this.handleSelect(path)
      }
    },
    handleClose(path) {
      /* 大屏屏蔽有下级菜单的菜单选中效果 */
      if (this.request_prefix !== "bigScreen" && !this.hasChildOnlyOpen) {
        this.handleSelect(path)
      }
    },
    async initDetailPageNavMenuData(plugin) {
      const { typeId, appId, engineId } = plugin
      if (!appId || !engineId) return
      const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
      this.fromDetailPage = true
      this.detailPageIds = {
        appId,
        engineId,
        typeId,
        pageId,
        wfwfid,
        websiteId
      }
      const { restUrl, restDataUrl } = await getAppointCacheData.call(
        this,
        pageId,
        wfwfid,
        websiteId,
        appId
      )
      let navMenuData,
        targetData = []
      navMenuData = restUrl.data.data.generalDataTypes
      this.recursiveFindDataTypesForDetailPage(navMenuData, targetData)
      this.$changeOptionsEV(targetData, "selectOptions", false, null, this.myid, true)
      this.$changeOptionsEV(!!typeId && typeId !== "0" ? typeId : navMenuData[0]?.publicId, "value", false, null, this.myid, true)
    },
    /**
     * 通过业务插件初始化面包屑数据
     * @param {*} plugin // 业务插件对象
     * @returns
     */
    initListPageNavMenuData(plugin) {
      const layout = this.$store.state[this.request_prefix].page.pageLayoutList
      const pageLayoutId = findCurrentComponentPathInLayoutByRectId(layout, this.myid.rect_id).join("_")
      sessionStorage.setItem("hasNavMenuVertical", "1")
      // 产品要求 不显示导航菜单时 右侧数据所占通栏宽度100%
      let layoutId = plugin.layoutId ? plugin.layoutId.substr(0, 5) : ""
      let navMenuData,
        targetData = []
      navMenuData = plugin.restUrl.data.data.generalDataTypes
      this.recursiveFindDataTypes(navMenuData, targetData)
      if (!plugin.showNavMenu || !targetData.length) {
        this.$changeOptionsEV(0, "opacity", false, null, { ...this.myid }, true)
        this.$changeOptionsEV(
          false,
          "isShow",
          false,
          null,
          {
            pageLayoutId: pageLayoutId
          },
          true
        )
        layoutId
          ? this.$changeOptionsEV(
              "100%",
              "width",
              false,
              null,
              {
                pageLayoutId: layoutId
              },
              true
            )
          : ""
        return
      } else {
        this.$changeOptionsEV(100, "opacity", false, null, { ...this.myid }, true)
        this.$changeOptionsEV(
          true,
          "isShow",
          false,
          null,
          {
            pageLayoutId: pageLayoutId
          },
          true
        )
        layoutId
          ? this.$changeOptionsEV(
              "77.2222%",
              "width",
              false,
              null,
              {
                pageLayoutId: layoutId
              },
              true
            )
          : ""
      }
      this.$changeOptionsEV(targetData, "selectOptions", false, null, this.myid, true)
      this.$changeOptionsEV(navMenuData[0]?.publicId, "value", false, null, this.myid, true)
    },
    /**
     * 通过业务插件初始化面包屑数据新版
     * @param {*} plugin // 业务插件对象
     * @returns
     */
    initSubPageNavMenuData(plugin) {
      const layout = this.$store.state[this.request_prefix].page.pageLayoutList
      const pageLayoutId = findCurrentComponentPathInLayoutByRectId(layout, this.myid.rect_id).join("_")
      sessionStorage.setItem("hasNavMenuVertical", "1")
      // 产品要求 不显示导航菜单时 右侧数据所占通栏宽度100%
      let layoutId = plugin.layoutId ? plugin.layoutId.substr(0, 5) : ""
      if (!plugin.showNavMenu) {
        this.$changeOptionsEV(0, "opacity", false, null, { ...this.myid }, true)
        this.$changeOptionsEV(
          false,
          "isShow",
          false,
          null,
          {
            pageLayoutId: pageLayoutId
          },
          true
        )
        layoutId
          ? this.$changeOptionsEV(
            "100%",
            "width",
            false,
            null,
            {
              pageLayoutId: layoutId
            },
            true
          )
          : ""
        return
      } else {
        this.$changeOptionsEV(100, "opacity", false, null, { ...this.myid }, true)
        this.$changeOptionsEV(
          true,
          "isShow",
          false,
          null,
          {
            pageLayoutId: pageLayoutId
          },
          true
        )
        layoutId
          ? this.$changeOptionsEV(
            "77.2222%",
            "width",
            false,
            null,
            {
              pageLayoutId: layoutId
            },
            true
          )
          : ""
      }
      let navMenuData,
        targetData = []
      navMenuData = plugin.restUrl.data.data.generalDataTypes
      this.recursiveFindDataTypes(navMenuData, targetData)

      this.$changeOptionsEV(targetData, "selectOptions", false, null, this.myid, true)
      this.$changeOptionsEV(navMenuData[0]?.publicId, "value", false, null, this.myid, true)
    },
    // 递归找到数据分类层级
    recursiveFindDataTypes(navMenuData, targetData) {
      for (let key in navMenuData) {
        targetData.push({
          label: navMenuData[key].name,
          value: navMenuData[key].url,
          iconUrl: navMenuData[key].iconUrl,
          publicId: navMenuData[key].publicId,
          openTarget: navMenuData[key].openTarget, // 1 当前窗口 2 新窗口
          openType: navMenuData[key].openType, // 1 自定义页面 2 链接地址
          showType: navMenuData[key].showType, // openType === 1 时  【0: 默认，1：列表、2：简介、3：简介+列表 4：简介+分类列
          children: []
        })
        if (typeof navMenuData[key].subGeneralDataTypes == "object") {
          this.recursiveFindDataTypes(navMenuData[key].subGeneralDataTypes, targetData[key].children)
        }
      }
    },
    // 递归找到数据分类层级
    recursiveFindDataTypesForDetailPage(navMenuData, targetData) {
      for (let key in navMenuData) {
        targetData.push({
          label: navMenuData[key].name,
          value: navMenuData[key].publicId,
          url: navMenuData[key].openType === 2 ? navMenuData[key].url : "",
          iconUrl: navMenuData[key].iconUrl,
          publicId: navMenuData[key].publicId,
          openTarget: navMenuData[key].openTarget, // 1 当前窗口 2 新窗口
          openType: navMenuData[key].openType, // 1 自定义页面 2 链接地址
          showType: navMenuData[key].showType, // openType === 1 时  【0: 默认，1：列表、2：简介、3：简介+列表 4：简介+分类列
          children: []
        })
        if (typeof navMenuData[key].subGeneralDataTypes == "object") {
          this.recursiveFindDataTypesForDetailPage(navMenuData[key].subGeneralDataTypes, targetData[key].children)
        }
      }
    },
    // 触发列表页数据刷新
    dispatchListPageRefreshData(typeId) {
      if (this.$subPageEvent.contexts) {
        let types = []
        Object.keys(this.$subPageEvent.contexts).forEach(key => {
          // if (key.indexOf("cxDataGrid") !== -1) {
          //   types.push("cxDataGrid")
          // }
          // if (key.indexOf("cxBreadCrumbs") !== -1) {
          //   types.push("cxBreadCrumbs")
          // }
          // if (key.indexOf("cxNoteEditor") !== -1) {
          //   types.push("cxNoteEditor")
          // }
          if (key.indexOf("cxDataGrid") !== -1 || key.indexOf("cxBreadCrumbs") !== -1 || key.indexOf("cxNoteEditor") !== -1) {
            types.push(key)
          }
        })
        if (types.length > 0) {
          this.$eventBus.$emit("subPage-component-init", {
            type: types,
            typeId: typeId
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.el-menu--vertical.el-menu::-webkit-scrollbar {
  width: 8px;
  height: 6px;
  display: block;
}
/* //滚动条的滑块 */
.el-menu--vertical.el-menu::-webkit-scrollbar-thumb {
  background: rgba(144, 147, 153, 0.3);
  border-radius: 3px;
}

::v-deep.menu_bigscreen.el-menu--vertical .el-submenu__title {
  overflow: hidden;
  /*white-space: normal;*/
}
/*动态 style 写入，打包后会失效*/
::v-deep.el-menu--vertical span{
  -webkit-background-clip: text
}
/* 一级菜单的标题 */
.el-menu--vertical .el-submenu /deep/.el-submenu__title,
.el-menu--vertical /deep/.el-menu-item {
  /* WebKit browsers*/
  color: var(--color);
  font-size: var(--fontSize);
  font-family: var(--fontFamily);
  font-weight: var(--fontWeight);
  /*height: var(--height);*/
  height: auto;
  white-space: normal;
  line-height: var(--lineHeight);
  text-align: var(--textAlign);
  text-decoration: var(--textDecoration);
  letter-spacing: var(--letterSpacing);
  writing-mode: var(--writingMode);
  font-style: var(--fontStyle);
  border-width: var(--borderWidth);
  border-style: var(--borderStyle);
  border-color: var(--borderColor);
  box-shadow: var(--boxShadow);
  width: var(--navWidth);
}
/* 只有大屏有间距设置 */
.menu_bigscreen.el-menu--vertical > .el-submenu,
.menu_bigscreen.el-menu--vertical > .el-menu-item {
  margin-bottom: var(--marginBottom);
}
.menu_bigscreen.el-menu--vertical .el-submenu /deep/.el-submenu,
.menu_bigscreen.el-menu--vertical .el-submenu /deep/.el-menu-item {
  margin-top: var(--liMarginBottom);
}

/* 仅限 1级菜单*/
::v-deep.el-menu--vertical > .el-submenu > .el-submenu__title,
::v-deep.el-menu--vertical > .el-menu-item {
  background: var(--backgroundColor);
  background-image: var(--backgroundImage);
  background-size: var(--backgroundSize);
  background-position: var(--backgroundPosition);
  background-repeat: var(--backgroundRepeat);
  background-color: var(--backgroundColor);
  border-radius: var(--borderRadius);
}
/*2级菜单 标题*/
/*::v-deep.el-menu--vertical .el-menu .el-submenu__title span,*/
/*::v-deep.el-menu--vertical .el-menu .el-menu-item span{*/
/*  color: var(--liColor);*/
/*}*/
::v-deep.el-menu--vertical .el-menu .el-submenu__title,
::v-deep.el-menu--vertical .el-menu .el-menu-item {
  height: var(--liHeight);
  line-height: var(--liLineHeight);
  box-shadow: var(--liBoxShadowStyle);
  background-image: var(--backgroundImage1);
  background-size: var(--backgroundSize1);
  background-position: var(--backgroundPosition1);
  background-repeat: var(--backgroundRepeat1);
  background-color: var(--backgroundColor1);
  font-size: var(--liFontSize);
  font-family: var(--liFontFamily);
  font-weight: var(--liFontWeight);
  width: var(--liWidth);
  border-width: var(--liBorderWidth);
  border-style: var(--liBorderStyle);
  border-color: var(--borderColor1);
  border-radius: var(--borderRadius1);
  text-align: var(--liTextAlign);
  text-decoration: var(--liTextDecoration);
  letter-spacing: var(--liLetterSpacing);
  writing-mode: var(--liWritingMode);
  font-style: var(--liFontStyle);

  /* 覆盖2级菜单本身的pandding 会导致无法对齐 */
  padding: 0;
}
/*2级菜单 整体*/
::v-deep.el-menu--vertical .el-submenu .el-menu {
  background: var(--liBackground);
}

/*下拉列表的悬浮样式*/

/* 1级菜单 悬浮 */
::v-deep.el-menu--vertical > .el-submenu > .el-submenu__title:hover span,
::v-deep.el-menu--vertical > .el-menu-item:hover span {
  color: var(--hoverColor) !important;
  background-image: var(--hoverBackgroundImage) !important;
}
::v-deep.el-menu--vertical > .el-submenu > .el-submenu__title:hover,
::v-deep.el-menu--vertical > .el-menu-item:hover {
  font-size: var(--hoverFontSize) !important;
  font-family: var(--hoverFontFamily) !important;
  font-weight: var(--hoverFontWeight) !important;
  /*height: var(--hoverLineHeight);*/
  line-height: var(--hoverLineHeight);
  text-align: var(--hoverTextAlign);
  text-decoration: var(--hoverTextDecoration);
  letter-spacing: var(--hoverLetterSpacing);
  writing-mode: var(--hoverWritingMode);
  font-style: var(--hoverFontStyle);

  border-width: var(--hoverBorderWidth);
  border-style: var(--hoverBorderStyle);
  border-color: var(--hoverBorderColor) !important;
  background: var(--hoverBackground) !important;
  background-image: var(--hoverBackgroundImage) !important;
  background-size: var(--hoverBackgroundSize) !important;
  background-position: var(--hoverBackgroundPosition) !important;
  background-repeat: var(--hoverBackgroundRepeat) !important;
  background-color: var(--hoverBackgroundColor) !important;
}
/*2级菜单 悬浮*/
::v-deep.el-menu--vertical .el-menu .el-submenu__title:hover span,
::v-deep.el-menu--vertical .el-menu .el-menu-item:hover span {
  color: var(--liHoverColor) !important;
  background-image: var(--liHoverBackgroundImage) !important;
}
::v-deep.el-menu--vertical .el-menu .el-submenu__title:hover,
::v-deep.el-menu--vertical .el-menu .el-menu-item:hover {
  /*background-color: transparent;*/
  /*color: var(--liHoverColor);*/
  font-size: var(--liHoverFontSize);
  font-family: var(--liHoverFontFamily);
  font-weight: var(--liHoverFontWeight);
  border-width: var(--liHoverBorderWidth);
  border-style: var(--liHoverBorderStyle);
  border-color: var(--liHoverBorderColor);
  /*background: var(--hoverBackground1);*/

  background-image: var(--hoverBackgroundImage1);
  background-size: var(--hoverBackgroundSize1);
  background-position: var(--hoverBackgroundPosition1);
  background-repeat: var(--hoverBackgroundRepeat1);
  background-color: var(--hoverBackgroundColor1);

  line-height: var(--liHoverLineHeight);
  /*height: var(--liHoverLineHeight);*/
  text-align: var(--liHoverTextAlign);
  text-decoration: var(--liHoverTextDecoration);
  letter-spacing: var(--liHoverLetterSpacing);
  writing-mode: var(--liHoverWritingMode);

  font-style: var(--liHoverFontStyle);
}

/* 图标 */
::v-deep .el-submenu__title > .icon {
  display: inline-block;
}
::v-deep .el-submenu__title > .right-icon {
  transform: translateY(-50%);
}
/* 展开后  图标 */
::v-deep .el-submenu.is-opened > .el-submenu__title > .right-icon {
  transform: rotate(180deg) translateY(50%);
}
::v-deep .el-submenu.is-opened > .el-submenu__title > .left-icon {
  transform: rotate(180deg);
}
::v-deep.el-menu--collapse .el-menu .el-submenu,
::v-deep .el-submenu .el-menu-item {
  min-width: 10px !important;
}
/*悬浮状态样式*/

/*激活状态样式 */

/* 1级菜单 选中 */
::v-deep.el-menu--vertical > .el-submenu.is-active > .el-submenu__title span,
::v-deep.el-menu--vertical > .el-menu-item.is-active span {
  color: var(--activeColor) !important;
  background-image: var(--activeBackgroundImage) !important;
}
::v-deep.el-menu--vertical > .el-submenu.is-active > .el-submenu__title,
::v-deep.el-menu--vertical > .el-menu-item.is-active {
  /*background: var(--activeBgColor) !important;*/
  background: var(--activeBackgroundColor) !important;
  background-image: var(--activeBackgroundImage) !important;
  background-size: var(--activeBackgroundSize) !important;
  background-position: var(--activeBackgroundPosition) !important;
  background-repeat: var(--activeBackgroundRepeat) !important;
  background-color: var(--activeBackgroundColor) !important;

  border-width: var(--activeBorderWidth);
  border-style: var(--activeBorderStyle);
  border-color: var(--activeBorderColor) !important;
  /*height: var(--activeLineHeight);*/
  line-height: var(--activeLineHeight);
  text-align: var(--activeTextAlign);
  text-decoration: var(--activeTextDecoration);
  letter-spacing: var(--activeLetterSpacing);
  writing-mode: var(--activeWritingMode);
  font-style: var(--activeFontStyle);
  font-size: var(--activeFontSize) !important;
  font-family: var(--activeFontFamily) !important;
  font-weight: var(--activeFontWeight) !important;
}
/* 2级菜单 选中 */
::v-deep.el-menu--vertical .el-submenu .el-submenu.is-active > .el-submenu__title span,
::v-deep.el-menu--vertical .el-submenu .el-menu-item.is-active span {
  color: var(--liActiveColor) !important;
  background-image: var(--liActiveBackgroundImage) !important;
}
::v-deep.el-menu--vertical .el-submenu .el-submenu > .el-submenu__title span,
::v-deep.el-menu--vertical .el-submenu .el-menu-item span{
  max-width: 100%;
  white-space: normal;
}
::v-deep.el-menu--vertical .el-submenu .el-submenu.is-active > .el-submenu__title,
::v-deep.el-menu--vertical .el-submenu .el-menu-item.is-active {
  /*color: var(--liActiveColor) !important;*/
  font-size: var(--liActiveFontSize) !important;
  font-family: var(--liActiveFontFamily) !important;
  font-weight: var(--liActiveFontWeight) !important;
  text-align: var(--liActiveTextAlign);
  text-decoration: var(--liActiveTextDecoration);
  letter-spacing: var(--liActiveLetterSpacing);
  writing-mode: var(--liActiveWritingMode);
  font-style: var(--liActiveFontStyle);
  border-width: var(--liActiveBorderWidth);
  border-style: var(--liActiveBorderStyle);
  border-color: var(--liActiveBorderColor);
  line-height: var(--liActiveLineHeight);
  /*height: var(--liActiveLineHeight);*/

  /*background: var(--activeBackground) !important;*/
  background-image: var(--activeBackgroundImage1) !important;
  background-size: var(--activeBackgroundSize1) !important;
  background-position: var(--activeBackgroundPosition1) !important;
  background-repeat: var(--activeBackgroundRepeat1) !important;
  background-color: var(--activeBackgroundColor1) !important;
}

::v-deep .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}
.el-menu {
  background-color: transparent;
}

::v-deep .el-submenu__title svg {
  vertical-align: top;
  width: 100%;
  height: 100%;
}
::v-deep .el-submenu__title svg * {
  stroke: var(--iconColor);
}
.el-submenu {
  background: transparent !important;
}
.el-menu--inline.el-menu {
  background: var(--backgroundColor);
}

/* 缩进样式 */
::v-deep.el-menu--vertical > .el-submenu > .el-submenu__title,
::v-deep.el-menu--vertical > .el-menu-item {
  padding-left: var(--leftIndent) !important;
  padding-right: 0;
}
::v-deep.el-menu--vertical > .el-submenu > .el-menu > .el-submenu > .el-submenu__title,
::v-deep.el-menu--vertical > .el-submenu > .el-menu > .el-menu-item {
  padding-left: calc(var(--leftIndent) * 2) !important;
}
::v-deep.el-menu--vertical > .el-submenu > .el-menu > .el-submenu > .el-menu > .el-submenu > .el-submenu__title,
::v-deep.el-menu--vertical > .el-submenu > .el-menu > .el-submenu > .el-menu > .el-menu-item {
  padding-left: calc(var(--leftIndent) * 3) !important;
}
::v-deep.el-menu--vertical
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-submenu__title,
::v-deep.el-menu--vertical > .el-submenu > .el-menu > .el-submenu > .el-menu > .el-submenu > .el-menu > .el-menu-item {
  padding-left: calc(var(--leftIndent) * 4) !important;
}
::v-deep.el-menu--vertical
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-submenu__title,
::v-deep.el-menu--vertical
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-menu-item {
  padding-left: calc(var(--leftIndent) * 5) !important;
}
::v-deep .data-icon {
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  width: 12px;
}
::v-deep.menu_bigscreen .el-submenu__title {
  display: block;
}
</style>
